import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "./endpoints";

export const logoutUser = async () => {
  try {
    let accessToken = document.cookie.split('; ').find(row => row.startsWith('accessToken='))?.split('=')[1]
    if (accessToken) {
      await axios({
        url: `${BASE_URL}/users/logout/`,
        method: "PUT",
        data: null,
        headers: {
          Authorization: `JWT ${accessToken}`,
        },
      })
    }
  } catch (error) {
  } finally {
    document.cookie = 'accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict; Secure';
    document.cookie = 'refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict; Secure';
    document.cookie = 'activesession=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict; Secure';
    window.dispatchEvent(new CustomEvent('auth:logout'));
    window.location.href = "/";
  }
};

export function usePreviousPath() {
  const previousPageUrl = document.referrer;
  let previousPath = null;
  if (previousPageUrl) {
    const url = new URL(previousPageUrl);
    previousPath = url.pathname;
  }
  return previousPath;
}

export function showApiErrors(error) {
  if (error.response && error.response.data) {
    const errData = error.response.data;

    // Handle stringified Python dictionary in 'error' field
    if (errData.error && typeof errData.error === "string") {
      if (errData.error.startsWith("{") && errData.error.endsWith("}")) {
        try {
          // Attempt to fix single quotes to double quotes for JSON parsing
          const validJsonStr = errData.error.replace(/'/g, '"');
          const parsedError = JSON.parse(validJsonStr);
          let hasFieldErrors = false;
          Object.entries(parsedError).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              hasFieldErrors = true;
              messages.forEach((msg) => {
                toast.error(`${msg}`);
              });
            } else if (typeof messages === "string") {
              hasFieldErrors = true;
              toast.error(`${messages}`);
            }
          });
          if (hasFieldErrors) return;
        } catch (e) {
          // If parsing fails, just show the raw error string
          toast.error(errData.error);
          return;
        }
      } else {
        toast.error(errData.error);
        return;
      }
    }

    // Handle nested error object
    if (errData.error && typeof errData.error === "object") {
      let hasFieldErrors = false;
      Object.entries(errData.error).forEach(([field, messages]) => {
        if (Array.isArray(messages)) {
          hasFieldErrors = true;
          messages.forEach((msg) => {
            toast.error(`${msg}`);
          });
        } else if (typeof messages === "string") {
          hasFieldErrors = true;
          toast.error(`${messages}`);
        }
      });
      if (hasFieldErrors) return;
    }

    if (!errData.data && !errData.message && typeof errData === "object") {
      let hasFieldErrors = false;
      Object.entries(errData).forEach(([field, messages]) => {
        if (Array.isArray(messages)) {
          hasFieldErrors = true;
          messages.forEach((msg) => {
            toast.error(`${msg}`);
          });
        } else if (typeof messages === "string") {
          hasFieldErrors = true;
          toast.error(`${messages}`);
        }
      });
      if (hasFieldErrors) return;
    }

    if (errData.data && typeof errData.data === "object") {
      Object.entries(errData.data).forEach(([field, messages]) => {
        if (Array.isArray(messages)) {
          messages.forEach((msg) => {
            toast.error(`${msg}`);
          });
        } else if (typeof messages === "string") {
          toast.error(`${messages}`);
        }
      });
    } else if (typeof errData.data === "string") {
      toast.error(errData.data);
    } else if (errData.data == null && errData.message) {
      toast.error(errData.message);
    } else {
      toast.error("Something went wrong. Please try again.");
    }
  } else {
    toast.error("Something went wrong. Please try again.");
  }
}

export function handleErrorRedirection(error) {
  if (error.response && error.response.status === 403) {
    window.location.href = "/unauthorized";
  }
}

function formatFieldName(field) {
  return field
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function formatRoleDisplay(role) {
  if (!role) return "";

  return role.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}
